import { Typography } from '@mui/material';

export const OtherReason = ({ otherReason }) => {
  return (
    <>
      <Typography>{otherReason}</Typography>
    </>
  );
};
